<template>
  <v-layout row wrap justify-center align-center fluid class="no-gutters pt-8">
    <v-flex xs12 sm7>
      <v-breadcrumbs v-if="!cardando"
          class="py-2 px-0"
          :items="aItemsBreadcrumbs"
          divider=">"
        >
         <template v-slot:item="{ item }">
          <v-breadcrumbs-item :to="item.href" class="titlesdark--text">
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
        </v-breadcrumbs>
    </v-flex>
    <v-flex xs12 sm7>
      <v-container class="no-gutters" fluid>
        <v-row class="no-gutters">
          <v-col v-if="cardando">
            <v-skeleton-loader
              class="mx-auto"
              max-width="500"
              type="card-avatar, article"
            ></v-skeleton-loader>
          </v-col>
          <v-col cols="12" v-if="!cardando" class="cont-contenido">
            <h2 class="titulo-tema"> {{aContenidoActualizado[0].titulo_contenido}}</h2>
            <div class="mx-auto text-center cont-imagen" v-if="aContenidoActualizado[0].imagenes_api.length == 1 || aContenidoActualizado[0].imagenes_api.length == 0">
              <img width="100%"
              v-for="(itemImg , idx) in  aContenidoActualizado[0].imagenes_api"
              :key="'itemImg-'+idx" alt=""
              :src="itemImg" class="mx-auto"
              >
            </div>
            <div v-if="aContenidoActualizado[0].imagenes_api.length >= 2 " class="my-2">
              <v-window v-model="onboarding" >
                <v-window-item v-for="(item, n) in aContenidoActualizado[0].imagenes_api" :key="`item-${n}`">
                  <v-card class=" bred" color="transparent" flat>
                    <v-card-text class="pa-0">
                        <v-img  width="100%" :src="item" aspect-ratio="2" contain> </v-img>
                    </v-card-text>
                  </v-card>
                </v-window-item>
              </v-window>
              <!-- :class="{'noclick':currentText < dialogos.length-1}" -->
              <v-card-actions class="justify-space-between" >
                <v-btn fab small depressed color="primary" @click="prev">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-item-group light v-model="onboarding" class="text-center " mandatory>
                  <v-item v-for="n in aContenidoActualizado[0].imagenes_api.length" :key="`btn-${n}`" v-slot:default="{ active, toggle }" >
                    <v-btn small :input-value="active" icon @click="toggle">
                      <v-icon>mdi-record</v-icon>
                    </v-btn>
                  </v-item>
                </v-item-group>
                <v-btn fab small depressed color="primary" @click="next">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-card-actions>
            </div>
            <h4>{{aContenidoActualizado[0].fecha_publicacion}}</h4>
            <p class="mt-1" v-if="aContenidoActualizado[0].texto_contenido" v-html="textoFiltrado"></p>
            <v-divider></v-divider>
            <div v-if="aContenidoActualizado[0].titulo_documento">
              <h3>Documentos relacionados</h3>
              <v-icon >mdi-file-document-outline</v-icon>
              <a :href="aContenidoActualizado[0].documento_api[0]" target="_blank" >
                {{aContenidoActualizado[0].titulo_documento}}
              </a>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import navUser from '../components/nav-user'
export default {
  name: 'contenido',
  components: {
    navUser
  },
  data () {
    return {
      aContenidoActualizado: [],
      onboarding: 0,
      aItemsBreadcrumbs: [
        {
          text: 'Inicio',
          disabled: true,
          href: '/'
        },
        {
          text: '',
          disabled: true,
          href: 'estaractualizado'
        }
      ],
      numContenido: 0,
      cardando: false,
      textoFiltrado: ''
    }
  },
  methods: {
    next () {
      this.onboarding = this.onboarding + 1 === this.length
        ? 0
        : this.onboarding + 1
    },
    prev () {
      this.onboarding = this.onboarding - 1 < 0
        ? this.length - 1
        : this.onboarding - 1
    }
  },
  async mounted () {
    this.cardando = true
    await axios
      .get('' + this.$store.state.rutaApi + 'estar_actualizado')
      .then(response => (this.aContenidoActualizado = response.data))
      // console.log(this.aContenidoActualizado )
    this.aItemsBreadcrumbs[1].text = this.aContenidoActualizado[0].titulo_contenido
    this.cardando = false
  }
}
</script>
<style lang="scss" scoped>
.titulo-tema{
  color: #2B5AC4;
}
.cont-imagen{
  width: 100%;
}

.cont_buttons-slider{
  justify-content: center;
  .item-button{
    width: 15px;
    height: 15px;
  }
}
.cont-contenido{
  p{
    font-size: 1.1em;
  }
}
</style>
